import * as React from 'react'
import { withNamespaces } from 'react-i18next'
import {
    Row,
    Col,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label
} from 'reactstrap'
import Select from 'react-select'
import Spinner from 'react-bootstrap/Spinner'
import { AvForm, AvField } from 'availity-reactstrap-validation'
import { DivisionSizes } from '../../../../constants/Common'

const CreateAndEditModal = ({
    t,
    show,
    toggle,
    onSubmit,
    submitInProgress = false,
    division = null
}) => {
    const avFormRef = React.useRef()

    const sizes = [];

    for(const sizeKey in DivisionSizes){
        sizes.push({
            value : sizeKey,
            label : `${DivisionSizes[sizeKey]?.title} ${t("Employees")}`
        });
    }

    return (
        <Modal size='md' scrollable isOpen={show} backdrop='static'>
            <AvForm
                className='needs-validation'
                onValidSubmit={(e, values) => {
                    onSubmit &&
                        onSubmit(
                            values,
                            division ? 'edit' : 'create'
                        )
                }}
                ref={avFormRef}
            >
                <ModalHeader toggle={toggle}>
                    {division ? (
                        <React.Fragment>{`${t('Edit')} ${
                            division?.title
                        }`}</React.Fragment>
                    ) : (
                        <React.Fragment>{t('Add A New Department')}</React.Fragment>
                    )}
                </ModalHeader>

                <ModalBody>
                    <Row>
                        <Col sm='12' className='mb-3'>
                            <Label
                                className='form-label'
                                htmlFor='division-title'
                            >
                                {t('Title')}:
                            </Label>

                            <AvField
                                name='title'
                                type='text'
                                errorMessage={t('This field cannot be blank')}
                                className='form-control'
                                validate={{
                                    required: {
                                        value: true
                                    }
                                }}
                                defaultValue={division?.title}
                                id='division-title'
                            />
                        </Col>
                        <Col sm='12' className='mb-3'>
                            <Label
                                className='form-label'
                                htmlFor='division-short-name'
                            >
                                {t('Short Name')}:
                            </Label>

                            <AvField
                                name='shortName'
                                type='text'
                                errorMessage={t('This field cannot be blank')}
                                className='form-control'
                                validate={{
                                    required: {
                                        value: true
                                    }
                                }}
                                defaultValue={division?.short_name}
                                id='division-short-name'
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm='12' md='6' className='mb-3'>
                            <Label
                                className='form-label'
                                htmlFor='division-accountingCode'
                            >
                                {t('Accounting Code')}:
                            </Label>

                            <AvField
                                name='accountingCode'
                                type='text'
                                errorMessage={t('This field cannot be blank')}
                                className='form-control'
                                validate={{
                                    required: {
                                        value: true
                                    }
                                }}
                                defaultValue={division?.accounting_code}
                                id='division-accountingCode'
                            />
                        </Col>

                        <Col sm='12' md='6' className='mb-3'>
                            <Label
                                className='form-label'
                                htmlFor='division-size'
                            >
                                {t('Department Size')}:
                            </Label>

                            <Select
                                placeholder={t("Select") + "..."}
                                classNamePrefix="select2-selection"
                                options={ sizes }
                                menuPortalTarget={ document.body }
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                id='division-size'
                                onChange={(e) => {
                                    const sizeInput = avFormRef.current._inputs['divisionSize'];
                                    sizeInput.value = e.value;
                                    sizeInput.validate();
                                }}
                                defaultValue={division?.division_size && {
                                    value   :   division.division_size,
                                    label   :   `${DivisionSizes[division.division_size]?.title} ${t("Employees")}`
                                }}
                            />
                            <AvField
                                name="divisionSize"
                                type="hidden" 
                                errorMessage={t("This field cannot be blank")}
                                validate={{
                                    required: { value: true },
                                }}
                                defaultValue={ division?.division_size }
                            />
                        </Col>
                    </Row>

                    <ModalFooter>
                        <Button
                            color='primary'
                            outline
                            className='waves-effect waves-light'
                            type='button'
                            onClick={toggle}
                            disabled={submitInProgress}
                        >
                            {t('Cancel')}
                        </Button>

                        <Button
                            color='primary'
                            type='submit'
                            className='waves-effect waves-light'
                            disabled={submitInProgress}
                        >
                            {submitInProgress && (
                                <Spinner
                                    animation='border'
                                    variant='white'
                                    size='sm'
                                    className='me-1'
                                />
                            )}
                            {division ? (
                                <React.Fragment>
                                    {t('Save Changes')}
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    {t('Add Department')}
                                </React.Fragment>
                            )}
                        </Button>
                    </ModalFooter>
                </ModalBody>
            </AvForm>
        </Modal>
    )
}

export default withNamespaces()(CreateAndEditModal)
